<template>
    <ul class="footer-payments d-flex justify-content-center row">
        <li v-for="flag in flags" :key="flag.id" class="payment-img">
            <img
                :src="flag.image"
                :alt="flag.company || flag.label"
                :title="flag.company"
                loading="lazy"
                width="100"
                height="46">
        </li>
    </ul>
</template>

<script>
export default {
    name: 'PaymentFlags',
    props: {
        data: {
            default: Array,
            type: Array
        }
    },
    data() {
        return {
            flags: this.data
        }
    }
}
</script>

<style scoped>
.footer-payments .payment-img {
    width: 40px;
    height: 35px;
    margin: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.footer-payments .payment-img img {
    max-height: 100%;
}
</style>